import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { BsModalRef } from 'ngx-bootstrap/modal';
import {
  SafeHtmlPipe,
  SanitizerValueType,
} from '@pipes/safe-html/safe-html.pipe';

@Component({
  selector: 'app-confirmation-message-modal',
  standalone: true,
  imports: [CommonModule, SafeHtmlPipe],
  templateUrl: './confirmation-message-modal.component.html',
  styleUrls: ['./confirmation-message-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfirmationMessageModalComponent {
  @Input() confirmBtnText: string;
  @Input() declineBtnText: string;
  @Input() messageText: string;
  @Input() titleText?: string;
  @Input() customCloseAction?: boolean;
  @Input() extraConfirmBtnClasses?: string;
  @Input() extraDeclineBtnClasses?: string;
  @Input() extraTitleClasses?: string;
  @Input() extraTextClasses?: string;
  @Input() extraModalClasses?: string;

  @Output() response = new EventEmitter<boolean>();

  readonly SanitizerValueType = SanitizerValueType;

  constructor(public bsModalRef: BsModalRef) {}

  onDeclineClick() {
    this.response.emit(false);
    this.bsModalRef.hide();
  }

  onXClick() {
    if (this.customCloseAction) {
      this.bsModalRef.hide();
    } else {
      this.onDeclineClick();
    }
  }

  onConfirmClick() {
    this.response.emit(true);
    this.bsModalRef.hide();
  }
}
